import browserScripts from '@freecodecamp/browser-scripts/package.json';
import { awaitResponse } from './awaitable-messenger.js';
const typeScriptWorkerSrc = `/js/workers/${browserScripts.version}/typescript-worker.js`;
let worker = null;
function getTypeScriptWorker() {
    if (!worker) {
        worker = new Worker(typeScriptWorkerSrc);
    }
    return worker;
}
export function compileTypeScriptCode(code) {
    return awaitResponse({
        messenger: getTypeScriptWorker(),
        message: { type: 'compile', code },
        onMessage: (data, onSuccess, onFailure) => {
            if (data.type === 'compiled') {
                if (!data.error) {
                    onSuccess(data.value);
                }
                else {
                    onFailure(Error(data.error));
                }
            }
            else {
                onFailure(Error('unable to compile code'));
            }
        }
    });
}
export function setupTSCompiler(tsconfig) {
    return awaitResponse({
        messenger: getTypeScriptWorker(),
        message: { type: 'setup', ...(tsconfig && { tsconfig }) },
        onMessage: (data, onSuccess) => {
            if (data.type === 'ready') {
                onSuccess(true);
            }
            // otherwise it times out.
        }
    });
}
